import React from 'react'
import SuperAdminNav from '../../../components/superadminNavbar/superadminnav'

export default function Buyers() {
  return (
    <div className='flex'>
    <div className='bg-[#E7EFFA] h-screen' >
    <SuperAdminNav/>
    </div>
    <div>
     this is buyers
     </div>
     </div>
  )
}
